import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import Logger from '../../../../shared/logger';
import './style.scss';

export class PublicProfile {
    /* @ngInject */
    constructor($stateParams, $scope,
        TalentForEmployerService,
        NotificationService,
        CommonCodeService,
        PublicProfileLinkGenerator,
        PublicCandidateProfileService,
    ) {
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.NotificationService = NotificationService;
        this.CommonCodeService = CommonCodeService;
        this.PublicCandidateProfileService = PublicCandidateProfileService;

        const talentId = this.$stateParams.talentId;
        const workflowId = this.$stateParams.workflowId;
        const workflowCreatedDate = this.$stateParams.workflowDate;
        const profileForSubmissionParam = this.$stateParams.profileForSubmissionParam;

        this.loadData(talentId, workflowId, workflowCreatedDate, profileForSubmissionParam);
    }

    async loadData(talentId, workflowId, workflowCreatedDate, profileForSubmissionParam) {
        this.isDataLoaded = false;

        try {
            const { result: candidate } =
                await this.PublicCandidateProfileService.getProfile(talentId, workflowId, workflowCreatedDate, profileForSubmissionParam);
            this.candidate = this.getPreparedCandidate(candidate);
        } catch (error) {
            this.NotificationService.error('PROFILE_URL_DISPLAY_ERROR');
            Logger.error(error);
        } finally {
            this.isDataLoaded = true;
            this.$scope.$digest();
        }
    }

    getPreparedCandidate(candidate) {
        const currentJob = _.find(candidate.employmentHistory, { isCurrent: true });
        const previousJob = _.find(candidate.employmentHistory, { isCurrent: false });

        return {
            ...candidate,
            skills: candidate.matchedSkills,
            candidateData: {
                name: candidate.name,
                photos: candidate.photos,
                skills: candidate.skills,
            },
            showName: true,
            currentJob,
            previousJob,
            residency: this.CommonCodeService.getLocationString(candidate.residency),
            showContactInformation: false,
        };
    }
}

export const PublicCandidateProfileConfiguration = {
    template,
    controller: PublicProfile,
    controllerAs: 'publicProfileCtrl',
};

angular.module('TALENYA-FE')
    .component('publicCandidateProfile', PublicCandidateProfileConfiguration);
